export default {
  title: 'Audit logs/Emails',
  statusSelectTitle: 'Email status',
  datePickerTitle: 'Date sent',
  emailTo: 'Email to',
  emailFrom: 'Email from',
  emailDetailsModal: {
    title: 'Email details',
    navigation: {
      overview: 'Overview',
      history: 'History',
      content: 'Content',
    },
  },
  emailModalHistoryTab: {
    noHistory: 'There is no history for this email.',
    serverResponse: 'Server response',
  },
  emailModalOverviewTab: {
    emailId: 'Email ID',
    sentDate: 'Sent',
    sentTo: 'Sent to',
    sentBy: 'Sent by',
    caseRecordId: 'Case record ID',
    status: 'Status',
    subject: 'Subject',
    attachments: 'Attachments',
    fileName: 'File name',
    fileType: 'File type',
  },
  emailModalRawHTML: {
    editor: {
      placeholder: 'This email has no content',
    },
  },
  emailsTable: {
    table: {
      headers: {
        emailId: 'Email ID',
        emailFrom: 'From',
        emailTo: 'To',
        emailSubject: 'Subject',
        emailDate: 'Date',
        emailStatus: 'Status',
      },
    },
  },
};
